import type { RetailerType } from "./retailers";

export interface HawkFindRetailerOption {
  value: string;
  label: string;
  searchRetailer: RetailerType;
}

export const HAWK_FIND_RETAILER_OPTIONS: HawkFindRetailerOption[] = [
  { value: "walmart", label: "Walmart", searchRetailer: "walmart" },
  { value: "walmart_online", label: "Walmart Online", searchRetailer: "walmart" },
  { value: "target", label: "Target", searchRetailer: "target" },
  { value: "target_online", label: "Target Online", searchRetailer: "target" },
  { value: "home_depot", label: "HD", searchRetailer: "home_depot" },
  { value: "bestbuy", label: "Best Buy", searchRetailer: "bestbuy" },
  { value: "dollar_general", label: "Dollar General", searchRetailer: "dollar_general" },
  { value: "costco", label: "Costco", searchRetailer: "costco" },
  { value: "woot", label: "Woot", searchRetailer: "woot" },
];

const byRetailer = new Map(HAWK_FIND_RETAILER_OPTIONS.map((r) => [r.value, r] as const));

export function getHawkFindRetailerMeta(retailer: string): HawkFindRetailerOption {
  return byRetailer.get(retailer) ?? HAWK_FIND_RETAILER_OPTIONS[0];
}
